import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function CommunityGuidelines() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
            <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="guidelines-container faq terms-nd-condition my-3" style={{ padding: '60px 0', minHeight: '70vh' }}>
   <div  className={`container ${styles.container}`}>
        <header className="guidelines-header">
          <h1 className='main-heading text-left'>ResuMate Community Guidelines</h1>
          <p className='inner-heading text-left' style={{ fontWeight: '600', marginBottom: '10px' }}>Last Updated: January 3, 2026</p>
          <p>
            ResuMate is designed to help people build meaningful connections in a respectful, safe,
            and genuine way. To protect our community, all members are expected to follow these guidelines.
            By creating an account, you agree to abide by these rules and our Terms of Use.
          </p>
        </header>

        <article>
          <h2 className='inner-heading text-left'>1. Eligibility</h2>
          <ul className='terms-list'>
            <li>You must be at least 18 years old to use ResuMate.</li>
            <li>We may request ID verification to confirm your age or identity if needed.</li>
            <li>Violating the age requirement or providing false information may result in account suspension or termination.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>2. Profiles</h2>
          <ul className='terms-list'>
            <li>Be Real: Your profile must represent you truthfully. No fake identities, impersonations, or misleading details.</li>
            <li>Photos: Upload only clear photos of yourself. Do not use heavily altered images, group-only photos, or pictures of children.</li>
            <li>Usernames: Choose a name that reflects who you are. Avoid offensive words, symbols, or impersonating public figures.</li>
            <li>AI Content: Do not submit AI-generated content that misleads other users or impersonates someone else.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>3. Respectful Behavior</h2>
          <ul className='terms-list'>
            <li>Treat others with kindness. No harassment, bullying, or intimidation.</li>
            <li>Discrimination, hate speech, or degrading language based on race, ethnicity, gender, sexuality, religion, or disability will not be tolerated.</li>
            <li>Unwanted sexual advances, explicit images, or fetishization are strictly prohibited.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>4. Safety & Boundaries</h2>
          <ul className='terms-list'>
            <li>Never share or request explicit content, financial details, or banking information.</li>
            <li>Do not use ResuMate to promote, sell, or exchange goods, services, substances, or donations.</li>
            <li>Threats, violence, exploitation, blackmail, or encouraging harmful acts will result in immediate removal.</li>
            <li>Always use your judgment and follow personal safety precautions when interacting with others, both online and offline.</li>
            <li>If someone makes you feel unsafe, use the Help & Support feature.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>5. Authentic Connections</h2>
          <ul className='terms-list'>
            <li>Catfishing, misrepresentation, or creating multiple fake accounts is prohibited.</li>
            <li>Spamming, scams, pyramid schemes, or attempts to manipulate other members are not allowed.</li>
            <li>Automated or bulk messaging, bots, scripts, or other automated activity that interferes with the app is prohibited.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>6. Mental Health & Wellbeing</h2>
          <ul className='terms-list'>
            <li>We support open and honest conversations about personal struggles.</li>
            <li>Content that promotes self-harm, suicide, eating disorders, or harmful behavior is not allowed.</li>
            <li>If you or someone you know is struggling, please seek support from trusted professionals or local resources.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>7. Prohibited Content</h2>
          <p>You may not share:</p>
          <ul className='terms-list'>
            <li>Private or identifying information of others without consent (doxxing).</li>
            <li>Misleading or stolen photos, deepfakes, or AI-generated impersonations.</li>
            <li>Content promoting political campaigning, fundraising, or commercial advertising.</li>
            <li>Any unlawful, fraudulent, or harmful content.</li>
            <li>Content that violates ResuMate's Terms of Use.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>8. Reporting & Enforcement</h2>
          <ul className='terms-list'>
            <li>Our team reviews reports carefully and may take actions such as removing content, issuing warnings, temporarily suspending accounts, or permanently banning accounts.</li>
            <li>ResuMate is not responsible for the actions or behavior of other users.</li>
            <li>In serious cases, we may cooperate with law enforcement.</li>
            <li>False reports made in bad faith may result in consequences for the reporter.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>9. Appeals</h2>
          <p>
            If you believe your account was suspended or banned in error, contact us at{" "}
            <a className='email' href="mailto:info@resumate.org">info@resumate.org</a> to request a review. While not all
            decisions may be reversed, we will fairly review your appeal.
          </p>
        </article>

        <article>
          <h2 className='inner-heading text-left'>10. Off-Platform Behavior</h2>
          <p>
            Respect doesn’t end when you log out. Harmful actions toward other members outside
            ResuMate (e.g., on dates or through private messaging apps) may affect your
            account status.
          </p>
        </article>

        <article>
          <h2 className='inner-heading text-left'>11. International Compliance</h2>
          <p>
            ResuMate is available globally. You are responsible for following the laws of your
            country while using the app. Violations of local laws may result in suspension or
            account termination.
          </p>
        </article>

        <article>
          <h2 className='inner-heading text-left'>12. Our Commitment</h2>
          <p>
            We want ResuMate to remain a positive and safe space. By using this app, you agree to
            follow these guidelines. Together, we can build a community based on honesty, respect,
            and meaningful connection. Violations of these Community Guidelines may also constitute a violation of our Terms of Use, which can lead to additional enforcement actions.
          </p>
        </article>
</div>
      </main>

      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CommunityGuidelines;
